import { render, staticRenderFns } from "./Comisiones.vue?vue&type=template&id=a96a30e6&scoped=true"
import script from "./Comisiones.vue?vue&type=script&lang=js"
export * from "./Comisiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96a30e6",
  null
  
)

export default component.exports